import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/redirect'),
    // redirect: '/',
    children: [
      {
        path: '/index',
        component: () => import('@/views/index'),
        meta: {title: '首页'}
      },
      // {
      //   path: '/index_stu',
      //   component: () => import('@/views/index_stu'),
      //   meta: {title: '学生首页'}
      // },
      {
        path: '/news',
        component: () => import('@/views/news'),
        meta: {title: '新闻中心'}
      },
      {
        path: '/yyzx',
        component: () => import('@/views/yyzx'),
        meta: {title: '应用中心'}
      },
      {
        path: '/mine',
        component: () => import('@/views/mine'),
        meta: {title: '我的'}
      },
    ]
  },
  {
    path: '/search',
    component: () => import('@/views/search'),
    meta: {title: '搜索'}
  },
  // {
  //   path: '/appDetail',
  //   component: () => import('@/views/appDetail'),
  //   meta: {title: '应用详情'}
  // },
  {
    path: '/set',
    component: () => import('@/views/set'),
    meta: {title: '设置中心'}
  },{
    path: '/about-us',
    component: () => import('@/views/aboutUs'),
    meta: {title: '关于我们'}
  },{
    path: '/person-center',
    component: () => import('@/views/personCenter'),
    meta: {title: '个人中心'}
  },{
    path: '/my-apps',
    component: () => import('@/views/myApps'),
    meta: {title: '我的应用'}
  },
  // {
  //   path: '/tjfw',
  //   component: () => import('@/views/tjfw'),
  //   meta: {title: '推荐服务'}
  // },
  {
    path: '/message',
    component: () => import('@/views/message'),
    meta: {title: '消息中心'}
  }
  // {
  //   path: '/messageDetail',
  //   component: () => import('@/views/messageDetail'),
  //   meta: {title: '消息详情'}
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  localStorage.setItem('routerPath',to.path)
  next();
})

export default router
